(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("lwr-client"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["liferay-widgets-react-web/js/liferay-widgets-react-web", "keymirror", "lwr-client", "react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["change-record-portlet"] = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("keymirror"), require("lwr-client"), require("react"), require("prop-types"));
	else
		root["change-record-portlet"] = factory(root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["keymirror"], root["lwr-client"], root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ClassNames = exports.JournalEntryChangeRecordRenderer = exports.ChangeRecordList = exports.ChangeRecordListItem = exports.ChangeRecordActions = exports.JournalRenderer_ChangeRecord = exports.DetailsRenderer_ChangeRecord = exports.ChangeRecord = undefined;
	
	var _StoreFactory = __webpack_require__(2);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _ChangeRecordActions = __webpack_require__(9);
	
	Object.defineProperty(exports, 'ChangeRecordActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ChangeRecordActions).default;
	    }
	});
	
	var _ChangeRecordListItem = __webpack_require__(10);
	
	Object.defineProperty(exports, 'ChangeRecordListItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ChangeRecordListItem).default;
	    }
	});
	
	var _ChangeRecordList = __webpack_require__(13);
	
	Object.defineProperty(exports, 'ChangeRecordList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ChangeRecordList).default;
	    }
	});
	
	var _Constants = __webpack_require__(5);
	
	Object.defineProperty(exports, 'ClassNames', {
	    enumerable: true,
	    get: function get() {
	        return _Constants.ClassNames;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ChangeRecordWebApi = __webpack_require__(7);
	
	var _ChangeRecordWebApi2 = _interopRequireDefault(_ChangeRecordWebApi);
	
	var _JournalEntryChangeRecordRenderer = __webpack_require__(14);
	
	var _JournalEntryChangeRecordRenderer2 = _interopRequireDefault(_JournalEntryChangeRecordRenderer);
	
	var _ChangeRecordDetailsListRenderer = __webpack_require__(15);
	
	var _ChangeRecordDetailsListRenderer2 = _interopRequireDefault(_ChangeRecordDetailsListRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: { ChangeRecordWebApi: _ChangeRecordWebApi2.default }
	});
	
	var ChangeRecord = exports.ChangeRecord = undefined;
	var DetailsRenderer_ChangeRecord = exports.DetailsRenderer_ChangeRecord = _ChangeRecordDetailsListRenderer2.default;
	var JournalRenderer_ChangeRecord = exports.JournalRenderer_ChangeRecord = _JournalEntryChangeRecordRenderer2.default;
	
	exports.JournalEntryChangeRecordRenderer = _JournalEntryChangeRecordRenderer2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChangeRecordStore = getChangeRecordStore;
	
	var _ChangeRecordStore = __webpack_require__(3);
	
	var _ChangeRecordStore2 = _interopRequireDefault(_ChangeRecordStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var changeRecordStoreInstance = void 0; /**
	                                         * Created by Carsten Bühler
	                                         * User: CBuehler on 28.01.2016
	                                         * Copyright: xdot GmbH 2015
	                                         */
	
	function getChangeRecordStore(AppContext) {
	  return changeRecordStoreInstance || (changeRecordStoreInstance = AppContext.createStore(_ChangeRecordStore2.default));
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	var _ChangeRecordWebApi = __webpack_require__(7);
	
	var _ChangeRecordWebApi2 = _interopRequireDefault(_ChangeRecordWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 15.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ChangeRecordStore = function (_ClassRemoteDataStore) {
	    _inherits(ChangeRecordStore, _ClassRemoteDataStore);
	
	    function ChangeRecordStore(Dispatcher) {
	        _classCallCheck(this, ChangeRecordStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.ChangeRecord, _ChangeRecordWebApi2.default.loadObjectChangeRecordsFromService, undefined));
	    }
	
	    return ChangeRecordStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = ChangeRecordStore;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ClassNames = exports.ActionTypes = undefined;
	
	var _keymirror = __webpack_require__(6);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {}; /**
	                                             * Created by Carsten Bühler
	                                             * User: CBuehler on 08.12.2015
	                                             * Copyright: xdot GmbH 2015
	                                             */
	
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	  ChangeRecord: null
	});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(8);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	//const changeRecordService = (m, o) => Client.invoke('/change_record.changerecord/' + m, o);
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 08.12.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var changeRecordServiceWithContext = function changeRecordServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/change_record.changerecord/' + m, o, c);
	};
	
	var api = {
	    loadGroupChangeRecordsFromService: function loadGroupChangeRecordsFromService(query) {
	        return changeRecordServiceWithContext('list.3', {
	            start: query.start,
	            end: query.end
	        }, {});
	    },
	    loadObjectChangeRecordsFromService: function loadObjectChangeRecordsFromService(list) {
	        return changeRecordServiceWithContext('list-attached.5', {
	            className: list.byClassName,
	            classPK: list.byId,
	            start: list.start,
	            end: list.end
	        }, {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('ChangeRecordWebApi', api);
	
	exports.default = api;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var className = _Constants.ClassNames.ChangeRecord;
	
	var api = 'ChangeRecordWebApi';
	var listApiMethod = 'loadGroupChangeRecordsFromService';
	
	exports.default = {
	
	  list: function list(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, api + '.' + listApiMethod);
	  },
	  attachedList: function attachedList(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, api + '.' + 'loadObjectChangeRecordsFromService');
	  },
	
	  moreItems: function moreItems(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	  }
	
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangeRecordListItem = function ChangeRecordListItem(_ref) {
	    var item = _ref.item,
	        userMeta = _ref.userMeta;
	
	    return item ? _react2.default.createElement(
	        _liferayWidgetsReactWeb.AmdRequireComponent,
	        { dependencies: ['ChangeRecordRenderer/' + item.className] },
	        function (Renderer) {
	            return _react2.default.createElement(Renderer, { changeRecord: item, userMeta: userMeta || item.userMeta });
	        }
	    ) : _react2.default.createElement(
	        'div',
	        null,
	        'Keine Daten\xE4nderung vorhanden!'
	    );
	};
	
	ChangeRecordListItem.propTypes = {
	    item: _propTypes2.default.object,
	    userMeta: _propTypes2.default.object
	};
	
	exports.default = ChangeRecordListItem;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _ChangeRecordActions = __webpack_require__(9);
	
	var _ChangeRecordActions2 = _interopRequireDefault(_ChangeRecordActions);
	
	var _ChangeRecordListItem = __webpack_require__(10);
	
	var _ChangeRecordListItem2 = _interopRequireDefault(_ChangeRecordListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangeRecordListLink = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataList, 'list', (0, _StoreFactory.getChangeRecordStore)(_liferayWidgetsReactWeb.AppContext));
	
	var ChangeRecordList = function ChangeRecordList(_ref) {
	    var dataChangeRecords = _ref.dataChangeRecords;
	
	
	    var moreChangeRecords = function moreChangeRecords(query) {
	        _ChangeRecordActions2.default.moreItems(dataChangeRecords, query);
	    };
	
	    return _react2.default.createElement(ChangeRecordListLink, { list: dataChangeRecords,
	        ListItem: _ChangeRecordListItem2.default,
	        listSize: _liferayWidgetsReactWeb.ScrollableDataList.LIST_SIZE_LARGE,
	        onClickMore: moreChangeRecords.bind(undefined) });
	};
	
	ChangeRecordList.propTypes = {
	    dataChangeRecords: _propTypes2.default.string.isRequired
	};
	
	exports.default = ChangeRecordList;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChangeRecordListItem = __webpack_require__(10);
	
	var _ChangeRecordListItem2 = _interopRequireDefault(_ChangeRecordListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JournalEntryChangeRecordRenderer = function JournalEntryChangeRecordRenderer(_ref) {
	    var message = _ref.message,
	        entry = _ref.entry;
	
	    return _react2.default.createElement(_ChangeRecordListItem2.default, { item: message, userMeta: entry.userMeta });
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 15.02.2016
	    * Copyright: xdot GmbH 2015
	    */
	
	JournalEntryChangeRecordRenderer.propTypes = {
	    message: _propTypes2.default.object,
	    entry: _propTypes2.default.object
	};
	
	exports.default = JournalEntryChangeRecordRenderer;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _ChangeRecordActions = __webpack_require__(9);
	
	var _ChangeRecordActions2 = _interopRequireDefault(_ChangeRecordActions);
	
	var _ChangeRecordListItem = __webpack_require__(10);
	
	var _ChangeRecordListItem2 = _interopRequireDefault(_ChangeRecordListItem);
	
	var _Constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChangeRecordDetailsListRenderer = function (_React$Component) {
	    _inherits(ChangeRecordDetailsListRenderer, _React$Component);
	
	    function ChangeRecordDetailsListRenderer() {
	        _classCallCheck(this, ChangeRecordDetailsListRenderer);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ChangeRecordDetailsListRenderer.prototype.onClickMore = function onClickMore(listName) {
	        _ChangeRecordActions2.default.moreItems(listName);
	    };
	
	    ChangeRecordDetailsListRenderer.prototype.render = function render() {
	        var list = this.props.item;
	
	        return _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataList, { list: list,
	            ListItem: _ChangeRecordListItem2.default,
	            className: _Constants.ClassNames.CHANGE_RECORD,
	            listSize: 'list-large',
	            onClickMore: this.onClickMore.bind(this, list.name) });
	    };
	
	    return ChangeRecordDetailsListRenderer;
	}(_react2.default.Component);
	
	ChangeRecordDetailsListRenderer.propTypes = {
	    item: _propTypes2.default.object.isRequired
	};
	
	exports.default = ChangeRecordDetailsListRenderer;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// change-record-portlet.js